'use strict';

import _ from 'lodash';

import './CurrentPaymentPlan.less';

import Frame from 'ck-core-client/source/ui/Frame';
import RoundButton from 'ck-core-client/source/ui/RoundButton';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ConnectedPaymentForm } from 'ck-website/source/components/PaymentForm';
import CurrencyPropType from './CurrencyPropType';
import CurrentPlanStatusAndActions from './CurrentPlanStatusAndActions';
import PlanInfoPropType from './CurrentPlanInfoPropType';
import { PRODUCT_ID } from 'ck-core/source/data/Product';
import { PLAN_SIZE } from 'ck-core/source/data/PlanSize';

export default class CurrentPaymentPlan extends Component {
	constructor(props) {
		super(props);

		this.state = {
			paymentForm: null
		};
	}

	commonUserProps() {
		return _.omitBy(
			{
				billingMethod: this.props.billingMethod,
				currency: this.props.currency,
				allowCurrencyChange: this.props.allowCurrencyChange
			},
			_.isNil
		);
	}

	showPaymentForm(props) {
		this.setState({
			checkout: null,
			paymentForm: _.defaults(this.commonUserProps(), props)
		});
	}

	goToChangePlanPage() {
		Frame.mod().navigate(`/change-plan/`);
	}

	goToCancelPage() {
		Frame.mod().navigate('/cancel/');
	}

	render() {
		let inner;

		if (this.state.paymentForm) {
			inner = (
				<div>
					<RoundButton text="Back" handleClick={() => this.setState({ paymentForm: null })} />
					<ConnectedPaymentForm {...this.state.paymentForm} />
				</div>
			);
		} else {
			inner = (
				<CurrentPlanStatusAndActions
					planInfo={this.props.planInfo}
					showPaymentForm={this.showPaymentForm.bind(this)}
					goToCancelPage={this.goToCancelPage.bind(this)}
					goToChangePlanPage={this.goToChangePlanPage.bind(this)}
				/>
			);
		}

		return (
			<section className="CurrentPaymentPlan">
				<div className="header">My Plan</div>
				{inner}
			</section>
		);
	}
}

CurrentPaymentPlan.propTypes = {
	planInfo: PlanInfoPropType,
	billingMethod: PropTypes.any,
	currency: CurrencyPropType,
	allowCurrencyChange: PropTypes.bool,
	handleCurrencyChange: PropTypes.func,
	handleCouponChange: PropTypes.func
};
